module.exports = __webpack_public_path__ + "media/front/images/twitter-a5ae10749bec30911306b467cbab6a8f.svg";